import { CreateOptionsParams, ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useClienteEventoService } from "@services/ClienteEventoService";
import React from "react";

export enum EnumClienteEventoTipo {
    None = "0",
    Cobranca = 1,
    BloqueioParcial = 2,
    BloqueioTotal = 3,
    Religacao = 4,
    Resgate = 5,
    AlteracaoGbs = 6,
    Cancelamento = 7,
    Excedentes = 8,
    Negociacao = 9,
    TrocaTitularidade = 10,
    TermoDevolucao = 11,
    Outros = 12
}

export interface IClienteEventoTipo {
    clienteEventoTipoId: number,
    nome: string,
    ativo: string
}

export type IComboClienteEventoTipo = ISpecializedCombo<IClienteEventoTipo>;

export function useClienteEventoTipoCombo (initialValue?: EnumClienteEventoTipo) : IComboClienteEventoTipo {
    const combo = useCombo<IClienteEventoTipo>({
        value: initialValue
    });

    const clienteEventoService = useClienteEventoService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((clienteEventoTipo, index) => {
            return <MenuItem key={index} value={clienteEventoTipo.clienteEventoTipoId}>{params?.prefix}{clienteEventoTipo.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(clienteEventoService.listarTiposAtivos)
    }, [combo, clienteEventoService.listarTiposAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}